import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { fmtFieldDate, siteReadOnly, type FieldSite } from '@entities/field';
import { useAgentPermission } from '@entities/user';

const Box = styled.div.attrs({ role: 'status' })`
  border: 1px solid ${({ theme }) => theme.colors.status.warning};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 14px;
  line-height: 1.6;
`;

/**
 * «Проект ПТО в корзине — площадка только для чтения»: проект площадки помечен
 * на удаление, и сервер отклоняет любую запись (409) до его восстановления.
 * Рапорты, факты, заявки и фото по-прежнему открываются — кнопки записи страница
 * прячет сама ([`siteReadOnly`]). Площадка с живым проектом — ничего.
 */
export function ProjectInBinBanner({
  site,
}: {
  site: Pick<FieldSite, 'project_deleted_at'> | null | undefined;
}) {
  const pto = useAgentPermission('pto');
  if (!siteReadOnly(site)) return null;
  return (
    <Box>
      <strong>Проект ПТО в корзине — площадка только для чтения.</strong> Проект помечен на удаление{' '}
      {fmtFieldDate(site?.project_deleted_at)}: рапорты, факты объёма, заявки и фото можно смотреть,
      но не менять. Чтобы продолжить работу, восстановите проект в{' '}
      {pto.can_read ? (
        <Link to="/agents/pto">списке проектов ОСНОВА.Инженер</Link>
      ) : (
        'списке проектов ОСНОВА.Инженер'
      )}{' '}
      («Показать помеченные на удаление» → «Восстановить»).
    </Box>
  );
}
